export enum Company {
    CHARGE_AMPS = 'ChargeAmps',
    FORTUM = 'Fortum',
}

const url = new URL(global.location.href)

export const currentCompany =
    location.host === 'fortums.charge.space' ||
    location.host === 'fortum.charge.space' ||
    url.pathname.includes('test=fortum')
        ? Company.FORTUM
        : Company.CHARGE_AMPS
